import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Selectors from '../selectors';
import Actions from '../action';

import CrmAdminAcceptPresentational from './crm-admin-accept-presentational';

const CrmAdminAcceptFunctional = ({
	approve,
	reject,
	authorize,
	crmLoading,
	history,
	params: { id },
	isApproving,
	isRejecting,
	response,
	userDetails,
}) => {
	const handleApprove = () => approve(id);
	const handleReject = () => reject(id);
	useEffect(() => {
		authorize(id);
	}, []);
	return (
		<CrmAdminAcceptPresentational
			isApproving={isApproving}
			isRejecting={isRejecting}
			approve={approve}
			response={response}
			userDetails={userDetails}
			handleReject={handleReject}
			handleApprove={handleApprove}
			crmLoading={crmLoading}
			history={history}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		crmLoading: Selectors.crmLoading(state),
		isApproving: Selectors.isApproving(state),
		isRejecting: Selectors.isRejecting(state),
		response: Selectors.response(state),
		userDetails: Selectors.userDetails(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		authorize: (request) => dispatch(Actions.creators.authorize(request)),
		approve: (request) => dispatch(Actions.creators.approve(request)),
		reject: (request) => dispatch(Actions.creators.reject(request)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(CrmAdminAcceptFunctional);

export default Connected;
